import React, { useContext, ReactNode, FC } from "react";
import {
  AccordionTitle,
  accordionContext,
} from "../../ActionsSelectors/Accordion";
import { RadioButton } from "../../ActionsSelectors/RadioButton";

/**
 * Helper component
 * Renders `RadioButton` along with children content, wrapped in `AccordionTitle`
 */
export const OptionTitle: FC<{ children?: ReactNode }> = ({ children }) => {
  const context = useContext(accordionContext);

  return (
    <AccordionTitle classes={{ root: "d-flex align-items-start" }}>
      <RadioButton checked={context?.expanded} />
      {children}
    </AccordionTitle>
  );
};

export default OptionTitle;
